import React from "react";

const TqPanelTable = ({
  panelQuoteData,
  sabreSchemes,
  getSchemeImage,
  handleBuyClick,
  onOpen,
  splitForSpace,
  watch,
  star,
  excessReductions,
}) => {
  const sortedConfigs = React.useMemo(
    () =>
      panelQuoteData?.panelMemberPanelConfigs
        ? [...panelQuoteData?.panelMemberPanelConfigs].sort(
            (a, b) => a.order - b.order
          )
        : [],
    [panelQuoteData]
  );

  return (
    <table className="tqPanelTable">
      <thead>
        <tr>
          <th className={excessReductions ? "th-border" : ""}>Provider</th>
          <th className={excessReductions ? "th-border" : ""}>
            Annual
            <br />
            Price
          </th>
          <th className={excessReductions ? "th-border" : ""}>
            Monthly Installments
          </th>
          <th className={excessReductions ? "th-border" : ""}>
            Policy Excesses
          </th>
          {sortedConfigs.map((config) => {
            if (config.code === "ER") return null;
            return (
              <th
                key={config.code}
                className={excessReductions ? "th-border" : ""}
              >
                {config.label}
              </th>
            );
          })}
          <th className={excessReductions ? "th-border" : ""}></th>
        </tr>
      </thead>
      <tbody>
        {panelQuoteData?.insurerResults?.quoted?.map((quote, index) => {
          const hasExcessReductions =
            sabreSchemes.includes(quote.schemeTableId) &&
            quote.panelMemberPanelItems.some(
              (item) => item.panelMemberPanelItemCode === "ER"
            );
          const excessReductionDetails = hasExcessReductions
            ? quote.panelMemberPanelItems.find(
                (item) => item.panelMemberPanelItemCode === "ER"
              )
            : null;
          return (
            <React.Fragment key={`row-${index}`}>
              <tr
                key={index}
                className={hasExcessReductions ? `tr-border` : ""}
              >
                <td>{getSchemeImage(quote.schemeTableId)}</td>
                <td className="QuotesPaymentStyle">
                  {quote.paymentOptions.map((option, optIndex) => (
                    <div key={optIndex}>
                      {option.paymentOptionName === "Payment in Full" && (
                        <div className="marginsDQuote">
                          <span
                            className="paymentsBold AnnualfontSize"
                            style={{ display: "block" }}
                          >
                            £
                            {option.totalAmountToPayByCustomer.toLocaleString(
                              "en-GB",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                  ))}
                </td>
                <td className="QuotesPaymentStyle">
                  {quote.paymentOptions.map((option, optIndex) => (
                    <div key={optIndex}>
                      {option.paymentOptionName ===
                        "Finance - Deposit and 9 Instalments" && (
                        <>
                          <div className="monthlyDiv border-bottom-blue">
                            <div className="marginsDQuoteCustom">
                              <span>Deposit </span>
                              <span>£{option.deposit}</span>
                            </div>
                            <div className="marginsDQuoteCustom">
                              <span>Monthly 9x </span>
                              <span>£{option.installmentAmount}</span>
                            </div>
                            <div className="marginsDQuoteCustom">
                              <span className="paymentsBold">Total </span>
                              <span className="paymentsBold">
                                £
                                {option.totalAmountToPayByCustomer.toLocaleString(
                                  "en-GB",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </span>
                            </div>
                          </div>
                          <div className="annStyle">
                            Paying by finance will cost you £
                            {quote.paymentOptions[0].serviceCharge.toFixed(2)}{" "}
                            more.
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </td>
                <td className="border-bottom-blue QuotesPaymentStyle">
                  {quote.panelMemberQuoteExcesses.map(
                    (excesses, excessesIndex) => (
                      <div
                        className="marginsDQuoteCustom"
                        key={`excess-${excessesIndex}`}
                      >
                        <span>{excesses.excessShortName}</span>
                        <span>£{excesses.excessAmount}</span>
                      </div>
                    )
                  )}
                </td>
                {sortedConfigs.map((config, configIndex) => {
                  if (config.code === "ER") return null;
                  const matchingItem = quote.panelMemberPanelItems.find(
                    (item) => item.panelMemberPanelItemCode === config.code
                  );
                  return (
                    <td
                      key={`config-${config.code}`}
                      className={configIndex === 0 ? "QuotesPaymentStyle" : ""}
                    >
                      {matchingItem
                        ? matchingItem.panelMemberPanelItemLines.map(
                            (line, lineIndex) => (
                              <div key={`line-${lineIndex}`}>
                                {configIndex === 0
                                  ? splitForSpace(line.panelItemLine)
                                  : line.panelItemLine}
                              </div>
                            )
                          )
                        : "£0"}
                    </td>
                  );
                })}
                <td className="buttons-td">
                  <button
                    type="button"
                    className="info-button"
                    onClick={() => onOpen(quote)}
                  >
                    Quote Details
                  </button>
                  <button
                    type="button"
                    className={`${
                      watch("isSelected") === index
                        ? "buy-button2"
                        : "buy-button"
                    }`}
                    onClick={(e) => handleBuyClick(e, index, quote)}
                  >
                    Select Quote
                  </button>
                </td>
              </tr>
              {hasExcessReductions && excessReductionDetails && (
                <tr>
                  <td colSpan={8} className="excessTd">
                    <div className="excessDiv">
                      <img src={star} alt="" />
                      <div>
                        <b>Excess Reduction: </b>
                      </div>
                      <div>
                        {excessReductionDetails.panelMemberPanelItemLines.map(
                          (line, lineIndex) => (
                            <span
                              key={`line-${lineIndex}`}
                              className="reductionItem"
                            >
                              {line.panelItemLine}
                            </span>
                          )
                        )}
                        *
                      </div>
                    </div>
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>
  );
};

export default TqPanelTable;
